import { ITask } from '../../TInvoker';

export default function findSuccessful(tasks: ReadonlyArray<ITask>): any {
    return tasks
        .find((item) => item.result?.value)?.result?.value;
}
